import moment from 'moment';

export default class Qualification {
  constructor(data) {
    this.title = data.title;
    this.qualifiedAt = data.qualified_at ? moment(data.qualified_at).format('YYYY-MM-DD') : '';
  }
}
